import { Modal } from "@circleco/compass/components/Modal";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { ShortcutsList } from "./ShortcutsList";

interface KeyboardShortcutsModalCompassProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const KeyboardShortcutsModalCompass = ({
  open,
  onOpenChange,
}: KeyboardShortcutsModalCompassProps) => (
  <Modal.Root open={open} onOpenChange={onOpenChange} size="lg">
    <Modal.Content>
      <Modal.Header title={t("header_v3.keyboard_shortcuts")} />
      <Modal.Body>
        <ShortcutsList
          renderCategory={category => (
            <Typography variant="label-md" color="primary">
              {category}
            </Typography>
          )}
        />
      </Modal.Body>
    </Modal.Content>
  </Modal.Root>
);

KeyboardShortcutsModalCompass.displayName = "KeyboardShortcutsModalCompass";
